import { getDefaultStore } from 'jotai';

import { ensurePermissionsAtom } from '../atoms';
import type { PermissionMode } from '../types';

/**
 * `useDesktopPermissionGate().ensurePermissions` for callers that cannot run a
 * hook. Writes the same atom on the app's default store, so the mounted gate
 * host opens the same modal.
 */
export const ensureDesktopPermissions = (mode: PermissionMode): Promise<boolean> =>
  getDefaultStore().set(ensurePermissionsAtom, mode);
